import Vue from 'vue';
import Router from 'vue-router';
import h5 from './h5';
Vue.use(Router);
const baseRouter = [];
function combineRouter(routers) {
  return routers.reduce((pre, cur) => pre.concat(cur), baseRouter);
}
const pageRouters = [
  h5,
];
const router = new Router({
  base: 'h5.html',
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: combineRouter(pageRouters),
});
export default router;
